var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconErrorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.725,
    height: 29.725,
    x: 0.637,
    y: 0.637,
    fill: "#FFF0F0",
    stroke: "#BA000D",
    strokeWidth: 0.725,
    rx: 14.863
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#BA000D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.45,
    d: "M14.527 8.548 7.23 20.264a1.609 1.609 0 0 0-.005 1.65c.149.25.364.46.623.607.26.147.554.226.855.229h14.592c.3-.003.596-.082.855-.229a1.69 1.69 0 0 0 .623-.608 1.608 1.608 0 0 0-.005-1.649L17.473 8.548a1.694 1.694 0 0 0-.628-.585 1.776 1.776 0 0 0-1.69 0c-.258.14-.474.341-.628.585v0ZM16 13v3M16 19h.009"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircle);
export default __webpack_public_path__ + "static/media/icon-error-circle.3cbc4e8c2742530fd39a63fa7fa95377.svg";
export { ForwardRef as ReactComponent };